export default "__VITE_ASSET__dc9cdc5c__"